import { toString } from './base';

export const isDef = <T = unknown>(val?: T): val is T => typeof val !== 'undefined';
export const isBoolean = (val: unknown): val is boolean => typeof val === 'boolean';
export const isFunction = <T extends (...args: unknown[]) => unknown>(val: unknown): val is T => typeof val === 'function';
export const isNumber = (val: unknown): val is number => typeof val === 'number';
export const isString = (val: unknown): val is string => typeof val === 'string';
export const isObject = (val: unknown): val is object => toString(val) === '[object Object]';
export const isUndefined = (val: unknown): val is undefined => toString(val) === '[object Undefined]';
export const isNull = (val: unknown): val is null => toString(val) === '[object Null]';
export const isRegExp = (val: unknown): val is RegExp => toString(val) === '[object RegExp]';
export const isDate = (val: unknown): val is Date => toString(val) === '[object Date]';

export const isWindow = (val: unknown): boolean => typeof window !== 'undefined' && toString(val) === '[object Window]';
export const isBrowser = () => typeof window !== 'undefined';
export const isServer = () => typeof window === 'undefined';

export const isTrue = (val: unknown): val is boolean => val === 'true' || val === true;
export const isObjEmpty = (obj: object): boolean => Object.keys(obj).length === 0 && Object.getOwnPropertyNames(obj).length === 0;
